import MobileDetect from 'mobile-detect';
import { getPath } from './Router/Router';
export const errorPage = 'error';
//TODO: make it and ENV variable
export const server = 'https://test.extrarelish.co.uk/xiasbio/wp-json/wp/v2/pages/?slug=';
export const media = 'https://test.extrarelish.co.uk/xiasbio/wp-json/wp/v2/media/';
export const post = 'https://test.extrarelish.co.uk/xiasbio/wp-json/wp/v2/submit-data/';
export var API;
(function (API) {
    API["setup"] = "api-setup";
    API["products"] = "api-products";
    API["team"] = "api-team";
    API["news"] = "api-news";
    API["events"] = "api-events";
})(API || (API = {}));
export const homePath = 'home';
export const solutionsPath = 'solutions';
export const productsPath = 'products';
export const footerKey = 'footer';
export const pageChangeTimeout = 0.5;
export const sectionChangeTimeout = 0.5;
export const sectionChangeTimeoutShort = 0.2;
export const tabletWidth = 1024;
export const mobileWidth = 600;
export const scrollEnableDelay = 250;
export const openAnimationTime = 450;
export const FOOTER_ID = 'footer';
export const isMobile = !!new MobileDetect(window.navigator.userAgent).mobile();
export const isAndroid = /Android/i.test(navigator.userAgent);
export const isBot = /bot|crawl|slurp|spider|google|bing|baidu|yandex/i.test(navigator.userAgent);
export const isMobileWidth = () => {
    return window.innerWidth <= mobileWidth;
};
export const fetchACFContent = (page) => new Promise(async (resolve, reject) => {
    try {
        const response = await fetch(`${server}${page}`);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        resolve(data);
    }
    catch (err) {
        return resolve(errorPage);
    }
    finally {
        return;
    }
});
export const asyncDelay = (s) => {
    return new Promise((resolve) => setTimeout(resolve, s * 1000));
};
// Compute the styles using CSS calc.
// Note: left and top are applied relative to the container's width and height, respectively.
// The left position is calculated by centering the element horizontally:
//   left = (100% * left) - (half of the computed width)
// Similarly, the top is calculated based on top and half of the computed height.
export const getAbsoluteSetupArray = (setup) => {
    // Parse the setup string. Expected format: "left,top,width,heightRatio"
    const parts = setup.split(',').map((s) => s.trim());
    if (parts.length !== 4) {
        console.error("Invalid setup format. Expected: 'left,top,width,heightRatio'");
        return ['0', '0', '0', '0'];
    }
    return parts;
};
export const getAbsoluteSetupCSS = (setupArray, options) => {
    const [left, top, width, heightRatio] = setupArray;
    const { noHeight, useLvh, useWindowHeight } = options ?? {};
    return {
        position: 'absolute',
        left: `${parseFloat(left) * 100}%`,
        top: `${parseFloat(top) * 100}${useLvh ? 'lvh' : '%'}`,
        width: `${parseFloat(width) * 100}%`,
        aspectRatio: noHeight || useWindowHeight ? undefined : `1 / ${heightRatio}`,
        height: useWindowHeight ? `${parseFloat(heightRatio) * 100}%` : undefined,
    };
};
export const getBackgroundPosition = (setup) => {
    const [left, top, scale] = setup;
    return {
        position: 'absolute',
        left: `0`,
        top: `0`,
        width: `100%`,
        height: `100%`,
        willChange: 'transform',
        transform: `translate(calc(var(--pageWidth) * ${parseFloat(left)}), calc(100lvh * ${parseFloat(top)})) scale(${parseFloat(scale)})`,
    };
};
export const getPointerTextPosition = (setupArray, horisontal_centered, vertical_centered) => {
    const [left, top, width, height] = setupArray;
    const baseSetup = horisontal_centered || vertical_centered
        ? {
            display: 'flex',
            alignItems: vertical_centered ? 'center' : 'flex-start',
            justifyContent: horisontal_centered ? 'center' : 'flex-start',
        }
        : {};
    return {
        ...baseSetup,
        left: `${parseFloat(left) * 100}%`,
        top: `calc(50% - (var(--centerContainerHeight) / 2) + var(--centerContainerHeight) * ${parseFloat(top)})`,
        width: `${parseFloat(width) * 100}%`,
        height: `calc(var(--centerContainerHeight) * ${parseFloat(height)})`,
    };
};
export const angleBetweenPoints = (p1, p2) => {
    const radians = Math.atan2(p2.y - p1.y, p2.x - p1.x);
    return radians * (180 / Math.PI);
};
export const distanceBetweenPoints = (p1, p2) => {
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
};
export const parseStats = (flexString, data) => {
    const columnCount = flexString.split(',').length;
    const result = [];
    const valuesArray = data.split(';').filter(Boolean);
    for (let i = 0; i < valuesArray.length; i++) {
        const row = Math.floor(i / columnCount);
        if (!result[row]) {
            result.push([]);
        }
        result[row].push(valuesArray[i].replace(/(\r\n|\n|\r)/g, '').replace(/<br\s*\/?>/gi, '\n'));
    }
    return result;
};
/*
    SEO
*/
// There is a structural mistake by not having the same type to the ACF content key time to time.
// Here is a map to match them:
export const generateSitemap = async (links) => {
    // TODO: make it env variable
    const finalSite = 'https://www.xiasbio.com';
    const urls = links.map((slug) => {
        return `
<url>
<loc>${finalSite}${slug}</loc>
<changefreq>weekly</changefreq>
<priority>0.8</priority>
</url>`;
    });
    const xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls.join('\n')}
</urlset>`;
    console.log(xml); // 👉 Copy this from your browser console
};
export const getLinks = (data) => Object.keys(data).reduce((acc, key) => {
    if (key.includes('api-')) {
        return acc;
    }
    const k = getPath(key);
    if (data[k].isProductPage) {
        return [
            ...acc,
            {
                name: data[k].name || data[k].title || '',
                link: `/products/${k}`,
            },
        ];
    }
    return [
        ...acc,
        {
            name: data[k].name || data[k].title || '',
            link: `/${key === 'home' ? '' : key}`,
        },
    ];
}, []);
// TODO add api handling, like news, team, events etc.
export const generateSEOText = (data, pageContent, seoFilter, legal) => {
    const menuItems = getLinks(data).map((item) => {
        const { name, link } = item;
        return `<li><a href="${link}" aria-label="${name}, ${link.replace(/\//g, "")}">${name}</a></li>`;
    });
    const content = pageContent && pageContent.length
        ? generateSectionHTML(pageContent, seoFilter, data)
        : [];
    return `
  <header role="banner">
    <nav role="navigation" aria-label="Main menu">
      <ul>
        ${menuItems.join('')}
      </ul>
    </nav>
  </header>

  <main id="main-content" role="main">
    ${content.join('')}
  </main>
  ${legal
        ? `
    <footer role="contentinfo">
      <p>&copy; 2025 My Semantic Website. All rights reserved.</p>
    </footer>
  `
        : ''}
  `;
};
const generateSectionHTML = (sectionArray, seoFilter, data) => {
    const isTruthy = (value) => value !== null &&
        value !== undefined &&
        value !== false &&
        value !== '' &&
        !(Array.isArray(value) && value.length === 0);
    const countTruthyKeys = (obj) => Object.entries(obj)
        .filter(([key]) => key !== 'gradient' && key !== 'acf_fc_layout')
        .map(([, value]) => value)
        .filter(isTruthy).length;
    const extractContentRecursively = (obj, isFirstSection, titleUsed) => {
        if (typeof obj !== 'object' || obj === null)
            return '';
        let html = '';
        // Render link buttons and skip further recursion
        if ('url' in obj &&
            typeof obj.url === 'string' &&
            'title' in obj &&
            typeof obj.title === 'string') {
            return `<a href="${obj.url}" aria-label="${obj.title === 'Learn more' ? `Visit ${obj.url.replace(/\//g, "")}` : obj.title}">${obj.title}, visit ${obj.url.replace(/\//g, "")}</a>`;
        }
        // Render title as heading
        if ('title' in obj &&
            typeof obj.title === 'string' &&
            obj.title.trim() !== '') {
            if (!titleUsed.used && isFirstSection) {
                html += `<h1>${obj.title}</h1>`;
                titleUsed.used = true;
            }
            else {
                html += `<h2>${obj.title}</h2>`;
            }
        }
        // Render text line
        if ('text' in obj &&
            typeof obj.text === 'string' &&
            obj.text.trim() !== '') {
            html += `<p>${obj.text}</p>`;
        }
        for (const [key, value] of Object.entries(obj)) {
            const isFiltered = (seoFilter ?? []).includes(key) || key.includes('mobile');
            if (isFiltered)
                continue;
            if (Array.isArray(value)) {
                html += value
                    .map((item) => extractContentRecursively(item, isFirstSection, titleUsed))
                    .join('');
            }
            else if (typeof value === 'object') {
                html += extractContentRecursively(value, isFirstSection, titleUsed);
            }
            else if (typeof value === 'string' && value.trim() !== '') {
                html += `<p>${value}</p>`;
            }
        }
        return html;
    };
    const renderSection = (section, index, data) => {
        const { name, type } = section;
        const candidates = Object.entries(section).filter(([key, value]) => key !== 'gradient' &&
            key !== 'acf_fc_layout' &&
            typeof value === 'object' &&
            value !== null);
        let bestKey = '';
        let maxTruthyCount = -1;
        for (const [key, value] of candidates) {
            const count = countTruthyKeys(value);
            if (count > maxTruthyCount) {
                maxTruthyCount = count;
                bestKey = key;
            }
        }
        let mostFilled = section[bestKey];
        const isFirstSection = index === 0;
        const titleUsed = { used: false };
        switch (type) {
            case 'products_tile_view':
                mostFilled = { ...mostFilled, ...data[API.products] };
                break;
            case 'bespoke_solutions':
                mostFilled = {
                    ...mostFilled,
                    ...{
                        title: data[API.setup]?.bespoke_title,
                        details: data[API.setup]?.bespoke_details,
                    },
                };
                break;
            case 'team':
                mostFilled = { ...mostFilled, ...data[API.team] };
                break;
            case 'home_news':
                mostFilled = {
                    ...mostFilled,
                    news: data[API.news]?.news.map((item) => ({
                        url: item.link,
                        title: item.name,
                    })),
                };
                break;
            case 'events':
                mostFilled = {
                    ...mostFilled,
                    news: data[API.events]?.events.map((item) => ({
                        url: item.link,
                        title: item.name,
                    })),
                };
                break;
        }
        const innerHTML = extractContentRecursively(mostFilled, isFirstSection, titleUsed);
        return `<section aria-labelledby="${name}">${innerHTML}</section>`;
    };
    return sectionArray.map((item, index) => renderSection(item, index, data));
};
